import React from 'react';
import COLORS from '../../../../../common/styles/color-pallete';
import Uploader from '../components/Upload';
import { openSampleModal } from '../idVerificationFailure/PassportSampleModal';
import { IPassportUploadContainer } from '../Interfaces/interface';
import { Col, Row } from '../styles';
import { FileUploadTextContainer } from './styles';

export const PassportUploadContainer = (props: IPassportUploadContainer): React.ReactElement => {
  const { files, setFiles, fileErrorFlag, cmsData, isNiumForexUserFileSizeError } = props;

  return (
    <>
      <Uploader
        files={files}
        setFiles={setFiles}
        heading={cmsData?.myPassportHeading || 'Upload passport copy'}
        replaceText="Replace"
        isNiumForexUserFileSizeError={isNiumForexUserFileSizeError}
        error={fileErrorFlag}
      />
      <Row padding={[16, 0, 0, 0]}>
        <Col width={450}>
          <FileUploadTextContainer
            cursor={true}
            headerMarginTop={8}
            textColor={COLORS.darkBlue}
            fontWeight={700}
          >
            <span className="__description">
              {cmsData?.passportInfoMsg ||
                `Open personal details section and capture both pages clearly.`}
            </span>
            <span className="__heading" onClick={() => openSampleModal(cmsData)}>
              {cmsData?.viewSample || `View sample`}
            </span>
          </FileUploadTextContainer>
        </Col>
      </Row>
    </>
  );
};
